<template>
  <section class="hero is-bold app-navbar animated" :class="{ slideInDown: show, slideOutDown: !show }">
    <div class="hero-head">
      <nav class="navbar is-transparent">
        <div class="navbar-brand">
          <a class="navbar-item" href="/#">
            <img src="~assets/logo-white.png" />
            <span class="vue">{{ $t('index.navbar_title') }}</span>
          </a>
          <div class="navbar-burger burger animated is-hidden-tablet" @click="toggleSidebar(!sidebar.opened)">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div class="navbar-end is-hidden-touch">
          <div class="navbar-item">
            <div class="field is-grouped">
              <!-- <b-taglist attached>
                <b-tag type="is-default">beta</b-tag>
                <b-tag type="is-dark">1.1.56</b-tag>
              </b-taglist> -->
              <!-- <router-link v-if="!$auth.check()" to="/login" class="nav-item">Login</router-link> -->
              <!-- <a v-if="$auth.check()" @click="logout" class="nav-item">Logout</a> -->

              <div class="select is-small">
                <select v-model="$i18n.locale">
                  <option value="ru">Русский</option>
                  <option value="en">English</option>
                </select>
              </div>

            </div>
          </div>
        </div>
      </nav>
    </div>
  </section>
</template>

<script>
// import Tooltip from 'vue-bulma-tooltip'
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    //Tooltip
  },

  props: {
    show: Boolean
  },

  computed: mapGetters({
    pkginfo: 'pkg',
    sidebar: 'sidebar',
    navbar: 'navbar'
  }),

  methods: {
    ...mapActions(['toggleSidebar', 'toggleNavbar']),
    logout() {
      this.$auth.logout({
        redirect: 'Home',
        makeRequest: false
        // params: {},
        // success: function () {},
        // error: function () {},
        // etc...
      });
    }
  },
  mounted() {
    var navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);
    // Check if there are any navbar burgers
    if (navbarBurgers.length > 0) {
      // Add a click event on each of them
      navbarBurgers.forEach(function($el) {
        $el.addEventListener('click', function() {
          // Get the target from the "data-target" attribute
          var target = $el.dataset.target;
          var $target = document.getElementById(target);
          // Toggle the class on both the "navbar-burger" and the "navbar-menu"
          $el.classList.toggle('is-active');
          try {
            $target.classList.toggle('is-active');
          } catch (error) {
            console.log(error);
          }
        });
      });
    }
  }
};
</script>

<style lang="scss">
@import '~bulma/sass/utilities/variables';
.hero-head {
  background: #339be1;
}
.navbar-item a,
.navbar-item i,
a.navbar-item {
  color: #fff;
  background-color: transparent;
  &:hover {
    color: #fff;
    background-color: transparent;
  }

  img {
    margin-right: 10px;
    max-height: auto;
  }
}

.navbar-link {
  &:after {
    border-color: #fff;
  }
}

.navbar-dropdown {
  a {
    color: #444;
  }
}
.app-navbar {
  position: fixed;
  min-width: 100%;
  z-index: 1024;
  box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(12, 0, 17, 0.1);

  .container {
    margin: auto 10px;
  }

  .nav-right {
    align-items: stretch;
    align-items: stretch;
    flex: 1;
    justify-content: flex-end;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
  }
}

.hero-brand {
  .vue {
    margin-left: 10px;
    color: #fff;
  }
  .admin {
    color: #fff;
  }
}
a.navbar-item:hover,
a.navbar-item.is-active,
a.navbar-link:hover,
a.navbar-link.is-active {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?d5ae70fc